export default {"src":"https://dap-qexpkq5xj-dap-rewrite.vercel.app/_next/static/media/notification_icon.762ae837.svg","height":27,"width":28};